<template>
    <div>
        <div class="card shadow-sm border-0">
            <div class="card-body p-0">
                <div class="header-activity p-3">
                    <h6 class="font-weight-bold m-0">Recent Activity</h6>
                </div>

                <div class="activity-feed p-3">
                    <!-- <div class="d-flex align-items-start">
                        <div class="avatar-container mr-3">
                            <img src="../assets/background.png" class="avatar" alt="avatar">
                        </div>
                        <div class="activity_message mr-3">
                            <p class="m-0">Bola has seen something cool and nice today</p>
                        </div>

                        <div class="activity_time ml-auto">
                            <p class="m-0">
                                <small class="text-muted">3d</small>
                            </p>
                        </div>

                    </div> -->

                    <div>
                        <h6>
                            <span class="fa fa-exclamation-circle"></span>
                            No recent activity
                        </h6>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        contributors: {
            type: Object
        },
        pool_id: {
            required: true
        }
    },

    created() {
        // this.fetchRecentPoolActivity()
    },

    methods: {
        async fetchRecentPoolActivity() {

            try {
                const activity = await axios.post(`/pool/activities/${this.pool_id}`);

                console.log(activity);
                
            } catch (error) {
                
            }
        }
    }

}
</script>

<style>

</style>